import React, {Component} from 'react';
import {Card, CardBody, CardTitle, Col, Row} from 'reactstrap';
import {Colxx} from "../../../components/common/CustomBootstrap";
import IconCard from "../../../components/cards/IconCard";
import {numberWithCommas} from "../../../helpers/Utils";
import {withTranslation} from "react-i18next";
import Api from '../../../services/Api';

class Stats extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: null,
    };
  }

  async componentDidMount() {
    await this.fetchData();
  }

  fetchData = async () => {
    const {match} = this.props;
    const {id} = match.params;
    try {
      const {data} = await Api.invoke('GET', `/v2/admin-ui/giftCards/stats/${id}`);
      this.setState({
        status: data,
      });
    } catch (e) {
      console.log("error: ", e);
    }
  };

  render() {
    const {status} = this.state;
    const {t, match, location} = this.props;
    const {count} = location.state;
    const {id} = match.params;
    return (
      <Row>
        <Colxx xxs="12">
          <Card className="h-100">
            <CardBody>
              <CardTitle className="text-large text-primary mb-5">
                {`${t('Gift Card Stats')} (${id})`}
              </CardTitle>
              <Row>
                <Col className='col-12 col-md-6 col-lg-6'>
                  <IconCard
                    icon="icon-Business-Mens"
                    title={t('Total Count')}
                    value={numberWithCommas(count)}
                  />
                </Col>
                <Col className='col-12 col-md-6 col-lg-6'>
                  <IconCard
                    icon="icon-Business-Mens"
                    title={t('Applied Count')}
                    value={status ? numberWithCommas(status.numActivated) : null}
                  />
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Colxx>
      </Row>
    );
  }
}

export default withTranslation()(Stats);
